import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 演算子 */
enum Operator {
  equals = '1',
  notEquals = '2',
}

const nameConfig = {
  equals: new Map([
    [Locale.ja, '一致する'],
    [Locale.en, 'Equals'],
  ]),
  notEquals: new Map([
    [Locale.ja, '一致しない'],
    [Locale.en, 'Not Equals'],
  ]),
};

const toEnum = rawValueToEnum(Operator, Operator.equals);
const toDisplay = enumToName(Operator, nameConfig);

export const operator = {
  enum: Operator,
  nameConfig,
  toEnum,
  toDisplay,
};
export type { Operator };
